import { IServiceProvider, ITemplateCacheService, forEach } from "angular";

export const vsServiceName = "workItemTypeService";
export const vsProviderName = `${vsServiceName}Provider`;

export interface WorkItemTypeConfig {
  name: string;
  template: string;
}

export class WorkItemTypeServiceProvider implements IServiceProvider {
  private readonly configs: WorkItemTypeConfig[] = [];

  addConfig(config: WorkItemTypeConfig) {
    this.configs.push(config);
  }

  $get = [
    "$templateCache",
    ($templateCache: ITemplateCacheService) => {
      const defaultConfig = {
        name: "default",
        template: "",
      };

      $templateCache.put(
        WorkItemTypeService.getWorkItemTypeTemplateName(defaultConfig),
        defaultConfig.template
      );
      forEach(this.configs, (config) => {
        $templateCache.put(
          WorkItemTypeService.getWorkItemTypeTemplateName(config),
          config.template
        );
      });

      return new WorkItemTypeService(this.configs, {
        name: "default",
        template: "",
      });
    },
  ];
}

export class WorkItemTypeService {
  constructor(
    private readonly configs: WorkItemTypeConfig[],
    private readonly defaultConfig: WorkItemTypeConfig
  ) {}

  getTemplateUrl(workItemType: string) {
    const config = this.configs.find((c) => c.name === workItemType);
    if (!config)
      return WorkItemTypeService.getWorkItemTypeTemplateName(
        this.defaultConfig
      );

    return WorkItemTypeService.getWorkItemTypeTemplateName(config);
  }

  static getWorkItemTypeTemplateName(config: WorkItemTypeConfig): string {
    return `workItemType${config.name}`;
  }
}
